var map = {
	"./symbol_0.png": 25923,
	"./symbol_1.png": 36090,
	"./symbol_2.png": 12337,
	"./symbol_3.png": 63944,
	"./symbol_4.png": 43559,
	"./symbol_5.png": 67774,
	"./symbol_6.png": 88149,
	"./symbol_7.png": 76524,
	"./symbol_8.png": 80539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78278;